import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from './Request';

export interface IGetSiteSAMLConfigurationParams {
}

export class GetSiteSAMLConfigurationRequest extends Request<IGetSiteSAMLConfigurationParams, ISiteSAMLConfiguration> {
  constructor() {
    super('getOrCreateSiteSAMLConfiguration', null);
  }
}
